import React, {Component} from 'react';
import {connect} from 'react-redux'
import FontIcon from 'material-ui/FontIcon';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import CardDeleteDialog from './CardDeleteDialog';
import CardChangeDialog from './CardChangeDialog';
import {sortAlphabetically, capitalizeFirstLetter} from "utils";
import { Element } from 'react-scroll';



import * as ReactDOM from "react-dom";
import {translate} from "react-i18next";


class HeaderTitle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hover: false,
        }
    }

    onMouseOver = () => {
        this.setState({hover: true});
    };

    onMouseLeave = () => {
        this.setState({hover: false});
    };

    iconBaseStyle = {
        fontSize: '24px',
        position: 'absolute',
        bottom: '18px',
    };

    render() {
        let iconStyle = null;
        let icon = null;
        if (this.state.hover || this.props.ordering) {
            iconStyle = {...this.iconBaseStyle, visibility: 'visible'};
        }
        else {
            iconStyle = {...this.iconBaseStyle, visibility: 'hidden'};
        }

        if (this.props.ordering === null || this.props.ordering === 'desc') {
            icon = <FontIcon className={"material-icons"} style={iconStyle}>arrow_drop_down</FontIcon>;
        }
        else {
            icon = <FontIcon className={"material-icons"} style={iconStyle}>arrow_drop_up</FontIcon>;
        }
        return (
            <span className={"cursorPointer"} onMouseLeave={this.onMouseLeave} onMouseOver={this.onMouseOver} onClick={() => {
                this.props.onClick()
            }}>{this.props.label}{icon}</span>
        )
    }

}


class CardList extends Component {

    constructor(props) {
        super(props);
        this.changeDialogRefs = {};
        this.state = {
            hoveredRowIndex: null,
            orderBy: 'n_word',
            orderType: 'asc'
        }
    }

    onRowHover = (rowIndex) => {
        this.setState({hoveredRowIndex: rowIndex});
    };

    onRowHoverExit = (rowIndex) => {
        this.setState({hoveredRowIndex: null});
    };

    onRowClick = (cardId) => {
        const domNode = ReactDOM.findDOMNode(this.changeDialogRefs[cardId]);
        domNode.click();
    };

    onHeaderColumnClick = (columnName) => {
        let orderBy = null;
        let orderType = null;
        if (columnName === 'nativeLang') {
            orderBy = 'n_word';
        }
        else if (columnName === 'foreignLang') {
            orderBy = 'f_word';
        }
        if (this.state.orderBy === orderBy) {
            if (this.state.orderType === 'asc') orderType = 'desc';
            else orderType = 'asc';
        }
        else {
            orderType = 'asc';
        }
        this.setState({orderBy, orderType});
    };

    saveChangeDialogRef = (cardId, ref) => {
        this.changeDialogRefs[cardId] = ref;
    };


    render() {
        const renderCard = (card, index) => {
            return (
                <TableRow onClick={() => this.onRowClick(card.id)} hoverable={true} selectable={false} key={card.id} style={{borderBottom: '1px solid rgb(224, 224, 224)'}}>
                    <TableRowColumn>{card.f_word}</TableRowColumn>
                    <TableRowColumn><Element name={"card-"+card.id} className="element" >{card.n_word}</Element></TableRowColumn>
                    <TableRowColumn>{card.example}</TableRowColumn>
                    <TableRowColumn style={{textAlign: 'right'}}>
                        <span style={{display: index === this.state.hoveredRowIndex ? 'inline-block' : 'none'}}>
                            <CardChangeDialog
                                ref={(ref) => (this.saveChangeDialogRef(card.id, ref))}
                                nativeLang={this.props.nativeLang}
                                foreignLang={this.props.foreignLang}
                                card={card}
                                wrapper={FontIcon}
                                wrapperProps={{
                                    style: {fontSize: '18px', paddingRight: '10px', cursor: 'pointer'},
                                    className: 'material-icons'
                                }}/>
                            <CardDeleteDialog
                                card={card}
                                wrapper={FontIcon}
                                wrapperProps={{
                                    style: {fontSize: '18px', paddingRight: '10px', cursor: 'pointer'},
                                    className: 'material-icons'
                                }}/>
                        </span>
                    </TableRowColumn>
                </TableRow>
            )
        };
        const cards = sortAlphabetically(this.props.cards, this.state.orderBy, {type: this.state.orderType, localeCompare: true});
        const renderedCards = cards.map((c, index) => renderCard(c, index));
        if (this.props.cards.length) {
            return (
                <div>
                    <Table onRowHover={this.onRowHover} onRowHoverExit={this.onRowHoverExit}>
                        <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                            <TableRow>
                                <TableHeaderColumn><HeaderTitle ordering={this.state.orderBy === 'f_word' ? this.state.orderType : null} onClick={() => {
                                    this.onHeaderColumnClick('foreignLang')
                                }} label={capitalizeFirstLetter(this.props.foreignLang.native_name)}/></TableHeaderColumn>
                                <TableHeaderColumn><HeaderTitle ordering={this.state.orderBy === 'n_word' ? this.state.orderType : null} onClick={() => {
                                    this.onHeaderColumnClick('nativeLang')
                                }} label={capitalizeFirstLetter(this.props.nativeLang.native_name)}/></TableHeaderColumn>
                                <TableHeaderColumn>{this.props.t('package_management_example_sentence')}</TableHeaderColumn>
                                <TableHeaderColumn/>
                            </TableRow>
                        </TableHeader>
                        <TableBody showRowHover={true} displayRowCheckbox={false}>
                            {renderedCards}
                        </TableBody>
                    </Table>
                </div>

            );
        }
        return (<p style={{paddingLeft: '20px'}}>{this.props.t('add_first_card_using_bar')}</p>)
    }
}


const mapStateToProps = (state) => {
    return {langs: state.lang.languages}
};

const mapDispatchToProps = (dispatch) => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(CardList));




// WEBPACK FOOTER //
// ./src/components/packages/CardList.js